export default {
	in: 'وارد',
	out: 'صادر'
}